import { Card } from "@/components/ui/card";
import { BookOpen } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";

const CHAPTERS = [
  {
    id: "moya-vs-smith",
    n: "01",
    title: "The Forest in Danger",
    body: "Tomorrow the Smith company arrives to raze the forest. Moya refuses to accept it — Dingo and every animal call this place home.",
  },
  {
    id: "kotzinon-arrives",
    n: "02",
    title: "The Arrival of Kotzinon",
    body: "A superhero from another world lands on Earth without his powers. His name is Kotzinon — and Moya is the first to see him.",
  },
  {
    id: "friendship-born",
    n: "03",
    title: "A Friendship is Born",
    body: "Boy and hero become partners. Together they set out to recover the lost powers and rally the Kotzinons back to full strength.",
  },
  {
    id: "team-assembles",
    n: "04",
    title: "The Kotzinons Assemble",
    body: "Kotzinena, Kotzinor, Kotzibam and Kotzibom step into the light — five heroes united to defend the forest they swore to protect.",
  },
];

function ChapterCard({ n, title, body, id }) {
  return (
    <Card
      className="relative p-6 rounded-2xl border border-border bg-[hsl(var(--kotz-ink-2))] overflow-hidden hover:border-[hsl(var(--kotz-gold))]/40 transition-colors duration-300"
      data-testid={`storybook-chapter-${id}`}
    >
      <span className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-grain opacity-30" />
      <p className="font-display text-5xl gold-text leading-none">{n}</p>
      <h3 className="mt-3 font-display text-xl tracking-wider text-foreground">{title}</h3>
      <p className="mt-2 text-sm text-foreground/65 leading-relaxed">{body}</p>
      <BookOpen className="absolute bottom-4 right-4 h-4 w-4 text-foreground/15" />
    </Card>
  );
}

export default function ChapterPreviewSection() {
  return (
    <section className="relative py-20 bg-[hsl(var(--kotz-ink-2))]/40">
      <div className="absolute inset-0 bg-grain opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Story Beats"
          title="WHAT'S INSIDE"
          subtitle="The adventure unfolds across four unforgettable movements — from a threatened forest to the birth of a superhero team."
          align="center"
          className="mx-auto mb-12"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CHAPTERS.map((ch) => (
            <ChapterCard key={ch.id} id={ch.id} n={ch.n} title={ch.title} body={ch.body} />
          ))}
        </div>
      </div>
    </section>
  );
}
